import { useEffect, useState } from "react";
import track from "../services/track.service";
import { Button, message, Spin } from 'antd';
import Loader from "../components/loader";
import tracks_service from "../services/track.service";
import { LoadingOutlined } from '@ant-design/icons';

/* -------------------------------------------------------------------------------- *\
|                               RaceCentralizer
\* -------------------------------------------------------------------------------- */
export default function RaceCentralizer()
{
    const [loading, setLoading] = useState(true);
    const [tracks,setTracks] = useState([]);

    /* -------------------------------------------------------------------------------- *\
    |                               getstate
    \* -------------------------------------------------------------------------------- */
    function getstate(t)
    {
        if (!t.local)
        {
            return "not in local";
        }
        if (!t.central)
        {
            return "not in central";
        }
        if (t.local.hash === t.central.hash)
        {
            return "same";
        }
        return "different";
    }
    /* -------------------------------------------------------------------------------- *\
    |                               refreshAll
    \* -------------------------------------------------------------------------------- */
    function refreshAll()
    {
        setLoading(true);
        track.getSynchro()
            .then((answer) =>
            {
                const newtracks = [];
                for (const t of answer.data)
                {
                    newtracks.push(
                    {
                        code: t.code,
                        sic: t.sic,

                        local: t.local,
                        central: t.central,

                        same: t.local && t.central && t.local.hash === t.central.hash,
                        state: getstate(t)
                    });
                }
                setTracks(newtracks);
            })
            .catch((error) => { setTracks([]); message.error(error.message || "Internal error"); })
            .finally(() => setLoading(false));
    }
    /* -------------------------------------------------------------------------------- *\
    |                               downloadlocal
    \* -------------------------------------------------------------------------------- */
    function downloadcsv(track, local)
    {
        if (local && !track.local) return;
        if (!local && !track.central) return;

        const req = local ? tracks_service.getContent(track.local.uuid) : tracks_service.getContentCentral(track.sic, track.code);
        req.then(r =>
        {
            if (!r.data || !r.data.content) return;

            const blob = new Blob([r.data.content], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            if (local)
            {
                link.download = track.sic + '_' + track.code + '_' + track.local.type + '_' + track.local.distance + '_' + track.code + '_local.csv';
            }
            else
            {
                link.download = track.sic + '_' + track.code + '_' + track.central.type + '_' + track.central.distance + '_' + track.code + '_central.csv';
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Libérer l'URL après usage
            URL.revokeObjectURL(url);
        })
        .catch(error =>
        {
            message.error(error);
        });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               synchronize
    \* -------------------------------------------------------------------------------- */
    function synchronize(track)
    {
        if (!track.central) return;

        if (!window.confirm(`Are you sure to synchronize ${track.sic} ${track.code} ?`)) return;

        setLoading(true);
        tracks_service.synchronize(track.sic, track.code, track.central.distance, track.central.type)
            .then(() => { refreshAll(); message.success(`Synchronized ${track.sic} ${track.code}`) })
            .catch((err) => message.error(err?.response?.data?.message || "Internal error"))
            .finally(() => setLoading(false));
    }

    useEffect(() =>
    {
        refreshAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div className="header">
                <div className="page-infotracks-header">
                    <Button className="" onClick={refreshAll}>Refresh</Button>
                    { loading && <Loader/> }
                </div>
            </div>
            <div className="page-infotracks-body" style={{padding: 10}}>
                <div className="page-infotracks-mainheader">
                    <div className='page-infotracks-sep'>Local</div>
                    <div>Centralizer</div>
                </div>
                <div className="page-infotracks-line page-infotracks-header">
                    <div>SIC</div>
                    <div className='page-infotracks-sep'>Code</div>
                    <div>Distance</div>
                    <div>Type</div>
                    <div className='page-infotracks-sep'>Status</div>
                    <div>Distance</div>
                    <div className='page-infotracks-sep'>Type</div>
                    <div className='page-infotracks-sep'>Status</div>
                </div>
                {
                    tracks.map((track, i) =>
                    {
                        return (
                            <div key={'track' + i} className="page-infotracks-line page-infotracks-data">
                                <div>{track.sic}</div>
                                <div className='page-infotracks-sep'>{track.code}</div>

                                <div className={!track.local ? "page-infotracks-notfound" : ""}>{track.local?.distance}</div>
                                <div className={!track.local ? "page-infotracks-notfound" : ""}>{track.local?.type}</div>
                                <div className={(!track.local ? "page-infotracks-notfound" : "") + ' page-infotracks-sep'}>{track.local?.status}</div>

                                <div className={!track.central ? "page-infotracks-notfound" : ""}>{track.central?.distance}</div>
                                <div className={(!track.central ? "page-infotracks-notfound" : "") + ' page-infotracks-sep'}>{track.central?.type}</div>

                                <div className={(track.same ? "page-infotracks-same" : "page-infotracks-notsame") + ' page-infotracks-sep'}>{track.state}</div>
                                <div className="page-infotracks-actions">
                                    <Button size='small' disabled={!track.local} onClick={() => downloadcsv(track, true)}>Download local</Button>
                                    <Button size='small' disabled={!track.central} onClick={() => downloadcsv(track, false)}>Download central</Button>
                                    <Button size='small' disabled={!track.central} onClick={() => synchronize(track)}>Import from central</Button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {
                loading && 
                <div className="page-infotracks-loading">
                    <div className="page-infotracks-cont">
                        <div><div>Working...</div><div>Please wait</div></div>
                        <div>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: 'black' }} spin />} />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
